import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "finished",
  "use": "finished-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"finished\"><defs><style>#finished .cls-1{fill:#22b573;}</style></defs><path class=\"cls-1\" d=\"M37.80491,106.01039,6.34111,74.5466a14.78,14.78,0,0,1,0-20.92639h0a14.78,14.78,0,0,1,20.92639,0L48.1939,74.5466,100.7325,22.008a14.78,14.78,0,0,1,20.92639,0h0a14.78,14.78,0,0,1,0,20.92639L58.7313,105.862A14.64818,14.64818,0,0,1,37.80491,106.01039Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol